


















































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import SidePanel from '@/components/Shared/SidePanel.vue';
import ActivityStatusDisplay from '@/components/Activities/Display/ActivityStatus.vue';
import ActivityDto from '@/models/Activities/ActivityDto';
import ActivityCategoryDto from '@/models/Activities/ActivityCategoryDto';
import ActivityType, { ActivityTypeLabels, ActivityTypeIcons } from '@/models/Activities/ActivityType';
import ActivityStatus, { ActivityStatusLabels, ActivityStatusColors } from '@/models/Activities/ActivityStatus';
import ActivityEntityType, { ActivityEntityTypeLabels } from '@/models/Activities/ActivityEntityType';
import ActivityDirection from '@/models/Activities/ActivityDirection';
import CallOutcome, { CallOutcomeLabels } from '@/models/Activities/CallOutcome';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';
import PageNames from '@/router/PageNames';
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/modules/app';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import AgencyUserStatus from '@/models/AgencyUsers/AgencyUserStatus';
import { debounce } from 'lodash';
import { MailboxStatusResponse } from '@/models/Activities/EmailDraftRequest';
import EmailAttachmentDto from '@/models/Activities/EmailAttachmentDto';
import EmailAttachmentList from '@/components/Activities/EmailAttachmentList.vue';

@Component({
  name: 'ActivitySidePanel',
  components: { SidePanel, ActivityStatusDisplay, EmailAttachmentList },
  filters: {
    fallback(value: any, fallbackValue: string) {
      return value || fallbackValue;
    }
  }
})
export default class ActivitySidePanel extends GiganautVue {
  @Prop({ default: false })
  visible!: boolean;

  @Prop({ default: null })
  activity!: ActivityDto | null;

  @Prop({ default: false })
  createMode!: boolean;

  @Prop({ default: null })
  createActivityType!: ActivityType | null;

  // Initial direction for Call/Email activities (pre-populated from menu selection)
  @Prop({ default: null })
  createActivityDirection!: ActivityDirection | null;

  // Entity context for creating activities linked to an entity
  @Prop({ default: null })
  createEntityType!: ActivityEntityType | null;

  @Prop({ default: null })
  createEntityId!: string | null;

  // Email address to pre-populate for email activities (from contact/worker)
  @Prop({ default: null })
  createEntityEmail!: string | null;

  // When the panel is opened from an Opportunity, the parent passes the full
  // OpportunityDto so the panel can resolve recipients from the linked
  // Company / Location / Contact preloads + the prospect snapshot fields.
  @Prop({ default: null })
  createEntityOpportunity!: any | null;

  // Activity to create from (e.g., creating a follow-up task from an email)
  @Prop({ default: null })
  createFromActivity!: ActivityDto | null;

  // Reply mode props
  @Prop({ default: null })
  replyToActivity!: ActivityDto | null;

  @Prop({ default: false })
  replyAll!: boolean;

  @Prop({ default: false })
  chase!: boolean;

  StatusDisplayLocation = StatusDisplayLocation;

  // Edit state
  isEditing = false;
  entity: any = {};
  categories: ActivityCategoryDto[] = [];
  loadingCategories = false;
  valid = true;
  saving = false;
  completing = false;
  dueDateMenu = false;
  scheduledDateMenu = false;
  callDateMenu = false;
  callDurationMinutes: number = 5;

  // Entity picker state (for creating activities from main list)
  selectedEntityType: ActivityEntityType | null = null;
  entitySearchQuery = '';
  entitySearchResults: any[] = [];
  entitySearchLoading = false;
  selectedEntity: any = null;
  debouncedEntitySearch: any = null;

  // Email recipient options (populated from entity contacts)
  availableEmailOptions: { email: string; name: string; contactId?: string }[] = [];
  loadingEmailOptions = false;

  // Contact picker options (populated from contact_location for Location activities)
  locationContacts: { id: string; name: string }[] = [];
  loadingLocationContacts = false;

  // TinyMCE editor state for email body
  editorKey = 0;
  editorReady = false;

  // Email body viewing
  emailBodyHtml = '';
  loadingEmailBody = false;

  // Draft email lifecycle
  draftActivityId: string | null = null;
  draftUpdatedAt: Date | null = null;
  draftAttachments: EmailAttachmentDto[] = [];
  draftSaving = false;
  draftSending = false;
  // Identifies the create-panel configuration that initializeNewEntity() last
  // ran for, so the prop watchers below can't initialise the same panel twice.
  lastInitKey: string | null = null;
  // In-flight draft create, so concurrent callers share one POST.
  draftCreateRequest: Promise<void> | null = null;

  // Mailbox status (used for reply/chase email self-exclusion and signature)
  mailboxStatus: MailboxStatusResponse | null = null;

  get panelTitle(): string {
    if (this.createMode) {
      if (this.replyToActivity) {
        if (this.chase) return 'Chase';
        return this.replyAll ? 'Reply All' : 'Reply';
      }
      return `New ${this.editTypeLabel}`;
    }
    if (this.isEditing) {
      return 'Edit Activity';
    }
    return this.activity ? this.activity.subject : 'Activity';
  }

  get panelWidth(): string {
    return '550px';
  }

  // View mode computed properties
  get typeLabel(): string {
    if (!this.activity) return '';
    const type = this.activity.type;
    const direction = this.activity.direction;
    if (type === ActivityType.Email) {
      if (direction === 2) return 'Inbound Email';
      if (direction === 1) return 'Outbound Email';
    }
    if (type === ActivityType.Call) {
      if (direction === 2) return 'Inbound Call';
      if (direction === 1) return 'Outbound Call';
    }
    return ActivityTypeLabels[type] || 'Activity';
  }

  get typeIcon(): string {
    return this.activity ? ActivityTypeIcons[this.activity.type] || this.IconConstants.Activity : '';
  }

  get typeColor(): string {
    if (!this.activity) return 'grey';
    return this.getTypeColorByType(this.activity.type);
  }

  get statusLabel(): string {
    return this.activity ? ActivityStatusLabels[this.activity.status] || 'Unknown' : '';
  }

  get statusColor(): string {
    return this.activity ? ActivityStatusColors[this.activity.status] || 'grey' : 'grey';
  }

  get isNote(): boolean {
    return this.activity?.type === ActivityType.Note;
  }

  get isTask(): boolean {
    return this.activity?.type === ActivityType.Task;
  }

  get isCall(): boolean {
    return this.activity?.type === ActivityType.Call;
  }

  get isMeeting(): boolean {
    return this.activity?.type === ActivityType.Meeting;
  }

  get isEmail(): boolean {
    return this.activity?.type === ActivityType.Email;
  }

  get isCompleted(): boolean {
    return this.activity?.status === ActivityStatus.Completed;
  }

  get priorityLabel(): string {
    if (!this.activity?.taskPriority) return '-';
    switch (this.activity.taskPriority) {
      case 1: return 'Low';
      case 2: return 'Normal';
      case 3: return 'High';
      case 4: return 'Urgent';
      default: return '-';
    }
  }

  get callResultLabel(): string {
    if (!this.activity?.callOutcome) return '-';
    return CallOutcomeLabels[this.activity.callOutcome] || '-';
  }

  get directionLabel(): string {
    if (!this.activity?.direction) return '-';
    return this.activity.direction === ActivityDirection.Outbound ? 'Outbound' : 'Inbound';
  }

  get ownerAvatarUrl(): string {
    if (!this.activity?.owner?.avatar) return '';
    return AppModule.currentAgencyContext.storageSharedBaseUrl + '/avatars/2/' + this.activity.owner.id + '/resized-100/' + this.activity.owner.avatar;
  }

  get createdByAvatarUrl(): string {
    if (!this.activity?.createdBy?.avatar) return '';
    return AppModule.currentAgencyContext.storageSharedBaseUrl + '/avatars/2/' + this.activity.createdBy.id + '/resized-100/' + this.activity.createdBy.avatar;
  }

  // Edit/Create mode computed properties
  get currentActivityType(): ActivityType {
    if (this.createMode && this.createActivityType !== null) {
      return this.createActivityType;
    }
    return this.activity?.type || ActivityType.Note;
  }

  get editTypeLabel(): string {
    return ActivityTypeLabels[this.currentActivityType] || 'Activity';
  }

  get editTypeIcon(): string {
    return ActivityTypeIcons[this.currentActivityType] || this.IconConstants.Activity;
  }

  get editTypeColor(): string {
    return this.getTypeColorByType(this.currentActivityType);
  }

  get editIsNote(): boolean {
    return this.currentActivityType === ActivityType.Note;
  }

  get editIsTask(): boolean {
    return this.currentActivityType === ActivityType.Task;
  }

  get editIsCall(): boolean {
    return this.currentActivityType === ActivityType.Call;
  }

  get editIsMeeting(): boolean {
    return this.currentActivityType === ActivityType.Meeting;
  }

  get subjectRequired(): boolean {
    return this.editIsTask || this.editIsCall || this.editIsMeeting || this.editIsEmail;
  }

  get editIsEmail(): boolean {
    return this.currentActivityType === ActivityType.Email;
  }

  get editEmailReadOnly(): boolean {
    return !this.createMode && this.editIsEmail && !this.isDraftActivity;
  }

  get isDraftActivity(): boolean {
    return this.activity?.status === ActivityStatus.Draft;
  }

  get isOutboundEmailDraft(): boolean {
    return this.editIsEmail && (this.createMode || this.isDraftActivity);
  }

  get canSendEmail(): boolean {
    // A draft is not required up-front: sendEmail() will auto-create one if needed.
    // The draft-before-attachment flow is handled separately via onEnsureDraft().
    return this.entity.emailToAddresses && this.entity.emailToAddresses.length > 0 && !!this.entity.subject && !!this.entity.categoryId;
  }

  get statuses() {
    return [
      { value: ActivityStatus.Planned, label: ActivityStatusLabels[ActivityStatus.Planned] },
      { value: ActivityStatus.Completed, label: ActivityStatusLabels[ActivityStatus.Completed] },
      { value: ActivityStatus.Cancelled, label: ActivityStatusLabels[ActivityStatus.Cancelled] }
    ];
  }

  get priorities() {
    return [
      { value: 1, label: 'Low' },
      { value: 2, label: 'Normal' },
      { value: 3, label: 'High' },
      { value: 4, label: 'Urgent' }
    ];
  }

  get callOutcomes() {
    return [
      { value: CallOutcome.Connected, label: CallOutcomeLabels[CallOutcome.Connected] },
      { value: CallOutcome.NoAnswer, label: CallOutcomeLabels[CallOutcome.NoAnswer] },
      { value: CallOutcome.Engaged, label: CallOutcomeLabels[CallOutcome.Engaged] },
      { value: CallOutcome.Voicemail, label: CallOutcomeLabels[CallOutcome.Voicemail] }
    ];
  }

  get directions() {
    return [
      { value: ActivityDirection.Outbound, label: 'Outbound' },
      { value: ActivityDirection.Inbound, label: 'Inbound' }
    ];
  }

  get activeUsers() {
    return AgencySettingsModule.agencyUsers.filter(
      user => user.status === AgencyUserStatus.Active
    );
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get filteredDesks() {
    if (!this.entity.branchId) return [];
    // Desks are nested within branches
    const branch = AgencySettingsModule.branches.find(b => b.id === this.entity.branchId);
    return branch?.desks || [];
  }

  onBranchChanged() {
    // Reset desk when branch changes
    this.entity.deskId = null;
    // Auto-select first desk if only one
    const desks = this.filteredDesks;
    if (desks.length === 1) {
      this.entity.deskId = desks[0].id;
    }
  }

  // Show entity picker when creating from main list (not from an entity page)
  get showEntityPicker(): boolean {
    return this.createMode && this.createEntityType === null && !this.replyToActivity;
  }

  get entityTypeOptions() {
    return [
      { value: ActivityEntityType.Contact, label: 'Contact' },
      { value: ActivityEntityType.Company, label: this.Labels.company || 'Company' },
      { value: ActivityEntityType.Location, label: this.Labels.location || 'Location' },
      { value: ActivityEntityType.Worker, label: this.Labels.worker || 'Worker' },
      { value: ActivityEntityType.Job, label: 'Job' },
      { value: ActivityEntityType.Opportunity, label: 'Opportunity' },
    ];
  }

  get emailRecipientItems(): string[] {
    // Return just the email addresses for the combobox
    return this.availableEmailOptions.map(opt => opt.email);
  }

  /**
   * Returns the effective entity type for category filtering.
   * - When creating from entity context: uses createEntityType
   * - When creating from main list: uses selectedEntityType
   * - When editing: derives from the activity's primary entity
   */
  get effectiveEntityType(): ActivityEntityType | null {
    if (this.createMode) {
      // If we have a direct entity context (creating from entity page)
      if (this.createEntityType !== null) {
        return this.createEntityType;
      }
      // Otherwise use the selected entity type from the picker
      return this.selectedEntityType;
    }
    // When editing, use the activity's primary entity type
    return this.activity?.primaryEntityType || null;
  }

  /**
   * Returns categories filtered by the current activity type and entity type.
   * Uses the explicit boolean fields on ActivityCategoryDto.
   */
  get filteredCategories(): ActivityCategoryDto[] {
    const activityType = this.currentActivityType;
    const entityType = this.effectiveEntityType;

    // If we don't have entity type yet (in create mode from main list), return empty
    if (this.createMode && this.showEntityPicker && entityType === null) {
      return [];
    }

    // Filter categories by the activity type and entity type combination
    return this.categories.filter(category => {
      // Only include active categories
      if (!category.isActive) return false;

      // Check if the category is enabled for this entity type + activity type combination
      return this.isCategoryEnabledFor(category, entityType, activityType);
    });
  }

  /**
   * Show the Contact picker only while creating a Location-scoped activity
   * and once we know which location it's for.
   */
  get showLocationContactPicker(): boolean {
    if (!this.createMode) return false;
    if (this.effectiveEntityType !== ActivityEntityType.Location) return false;
    return !!this.currentLocationId;
  }

  /**
   * Resolve the location id whether the form is opened from a Location page
   * (createEntityId) or via the central entity picker (selectedEntity).
   */
  get currentLocationId(): string | null {
    if (this.createEntityType === ActivityEntityType.Location && this.createEntityId) {
      return this.createEntityId;
    }
    if (this.selectedEntityType === ActivityEntityType.Location && this.selectedEntity) {
      return this.selectedEntity.id;
    }
    return null;
  }

  async loadLocationContacts(locationId: string) {
    this.loadingLocationContacts = true;
    try {
      const response = await ajax.get(`/api/v1/agency/locations/${locationId}/contacts`);
      const contactLocations = response.data || [];
      this.locationContacts = contactLocations
        .filter((cl: any) => cl.contact)
        .map((cl: any) => ({
          id: cl.contact.id,
          name: cl.contact.person
            ? `${cl.contact.person.firstName} ${cl.contact.person.lastName}`.trim()
            : (cl.contact.emailAddress || 'Unnamed contact')
        }));
      this.autoSelectSingleLocationContact();
    } catch (error) {
      this.locationContacts = [];
    } finally {
      this.loadingLocationContacts = false;
    }
  }

  /**
   * Mirror of autoSelectSingleCategory: if only one contact is linked to the
   * location, pre-fill it so the user doesn't have to choose.
   */
  autoSelectSingleLocationContact() {
    if (!this.createMode || !this.entity || this.entity.contactId) return;
    if (this.locationContacts.length === 1) {
      this.entity.contactId = this.locationContacts[0].id;
    }
  }

  /**
   * When creating a new activity, if exactly one category is available
   * for the current entity/activity type combination, pre-select it.
   */
  autoSelectSingleCategory() {
    if (!this.createMode || !this.entity || this.entity.categoryId) return;
    if (this.filteredCategories.length === 1) {
      this.entity.categoryId = this.filteredCategories[0].id;
    }
  }

  /**
   * Checks if a category is enabled for a specific entity type and activity type combination.
   */
  isCategoryEnabledFor(category: ActivityCategoryDto, entityType: ActivityEntityType | null, activityType: ActivityType): boolean {
    if (entityType === null) return true; // No entity type filter

    // Map activity type to field suffix
    let activitySuffix = '';
    switch (activityType) {
      case ActivityType.Task: activitySuffix = 'Task'; break;
      case ActivityType.Note: activitySuffix = 'Note'; break;
      case ActivityType.Call: activitySuffix = 'Call'; break;
      case ActivityType.Meeting: activitySuffix = 'Meeting'; break;
      case ActivityType.Email: activitySuffix = 'Email'; break;
      default: return true;
    }

    // Map entity type to field prefix
    let entityPrefix = '';
    switch (entityType) {
      case ActivityEntityType.Worker: entityPrefix = 'Worker'; break;
      case ActivityEntityType.Company: entityPrefix = 'Company'; break;
      case ActivityEntityType.Location: entityPrefix = 'Location'; break;
      case ActivityEntityType.Contact: entityPrefix = 'Contact'; break;
      case ActivityEntityType.Job: entityPrefix = 'Job'; break;
      case ActivityEntityType.Booking: entityPrefix = 'Booking'; break;
      case ActivityEntityType.Campaign: entityPrefix = 'Campaign'; break;
      case ActivityEntityType.Opportunity: entityPrefix = 'Opportunity'; break;
      default: return true;
    }

    // Build the field name and check it
    const fieldName = `isEnabledOn${entityPrefix}${activitySuffix}` as keyof ActivityCategoryDto;
    return category[fieldName] === true;
  }



  // --- Task due date (endAt) computed properties ---
  get formattedDueDate(): string {
    if (!this.entity.endAt) return '';
    return new Date(this.entity.endAt).toLocaleDateString();
  }

  get dueDatePicker(): string {
    if (!this.entity.endAt) return '';
    return new Date(this.entity.endAt).toISOString().substr(0, 10);
  }

  set dueDatePicker(val: string) {
    if (!val) {
      this.entity.endAt = null;
      return;
    }
    // Preserve existing time or default to 09:00
    const existing = this.entity.endAt ? new Date(this.entity.endAt) : null;
    const hours = existing ? existing.getHours() : 9;
    const minutes = existing ? existing.getMinutes() : 0;
    const d = new Date(val);
    d.setHours(hours, minutes, 0, 0);
    this.entity.endAt = d;
  }

  get dueTime(): string {
    if (!this.entity.endAt) return '09:00';
    const d = new Date(this.entity.endAt);
    return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
  }

  set dueTime(val: string) {
    if (!val) return;
    const parts = val.split(':');
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const d = this.entity.endAt ? new Date(this.entity.endAt) : new Date();
    d.setHours(hours, minutes, 0, 0);
    this.entity.endAt = d;
  }

  // --- Meeting date/time computed properties ---
  get formattedMeetingDate(): string {
    if (!this.entity.startAt) return '';
    return new Date(this.entity.startAt).toLocaleDateString();
  }

  get meetingDatePicker(): string {
    if (!this.entity.startAt) return '';
    return new Date(this.entity.startAt).toISOString().substr(0, 10);
  }

  set meetingDatePicker(val: string) {
    if (!val) {
      this.entity.startAt = null;
      this.entity.endAt = null;
      return;
    }
    // Preserve existing time or default to 09:00
    const existingStart = this.entity.startAt ? new Date(this.entity.startAt) : null;
    const startHours = existingStart ? existingStart.getHours() : 9;
    const startMinutes = existingStart ? existingStart.getMinutes() : 0;
    const startDate = new Date(val);
    startDate.setHours(startHours, startMinutes, 0, 0);
    this.entity.startAt = startDate;

    // Also update endAt to same date, preserving end time or defaulting to 10:00
    const existingEnd = this.entity.endAt ? new Date(this.entity.endAt) : null;
    const endHours = existingEnd ? existingEnd.getHours() : 10;
    const endMinutes = existingEnd ? existingEnd.getMinutes() : 0;
    const endDate = new Date(val);
    endDate.setHours(endHours, endMinutes, 0, 0);
    this.entity.endAt = endDate;
  }

  get meetingStartTime(): string {
    if (!this.entity.startAt) return '09:00';
    const d = new Date(this.entity.startAt);
    return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
  }

  set meetingStartTime(val: string) {
    if (!val) return;
    const parts = val.split(':');
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const d = this.entity.startAt ? new Date(this.entity.startAt) : new Date();
    d.setHours(hours, minutes, 0, 0);
    this.entity.startAt = d;
  }

  get meetingEndTime(): string {
    if (!this.entity.endAt) return '10:00';
    const d = new Date(this.entity.endAt);
    return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
  }

  set meetingEndTime(val: string) {
    if (!val) return;
    const parts = val.split(':');
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    // Use startAt date for endAt, or today
    const baseDate = this.entity.startAt ? new Date(this.entity.startAt) : new Date();
    const d = new Date(baseDate);
    d.setHours(hours, minutes, 0, 0);
    this.entity.endAt = d;
  }

  clearMeetingDate() {
    this.entity.startAt = null;
    this.entity.endAt = null;
  }

  // --- Call date/time computed properties ---
  get formattedCallDate(): string {
    if (!this.entity.startAt) return '';
    return new Date(this.entity.startAt).toLocaleDateString();
  }

  get callDatePicker(): string {
    if (!this.entity.startAt) return '';
    return new Date(this.entity.startAt).toISOString().substr(0, 10);
  }

  set callDatePicker(val: string) {
    if (!val) {
      this.entity.startAt = null;
      this.entity.endAt = null;
      return;
    }
    const existingStart = this.entity.startAt ? new Date(this.entity.startAt) : null;
    const startHours = existingStart ? existingStart.getHours() : 9;
    const startMinutes = existingStart ? existingStart.getMinutes() : 0;
    const startDate = new Date(val);
    startDate.setHours(startHours, startMinutes, 0, 0);
    this.entity.startAt = startDate;

    const existingEnd = this.entity.endAt ? new Date(this.entity.endAt) : null;
    const endHours = existingEnd ? existingEnd.getHours() : 10;
    const endMinutes = existingEnd ? existingEnd.getMinutes() : 0;
    const endDate = new Date(val);
    endDate.setHours(endHours, endMinutes, 0, 0);
    this.entity.endAt = endDate;
  }

  clearCallDate() {
    this.entity.startAt = null;
    this.entity.endAt = null;
  }

  get callStartTime(): string {
    if (!this.entity.startAt) return '09:00';
    const d = new Date(this.entity.startAt);
    return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
  }

  set callStartTime(val: string) {
    if (!val) return;
    const parts = val.split(':');
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const d = this.entity.startAt ? new Date(this.entity.startAt) : new Date();
    d.setHours(hours, minutes, 0, 0);
    this.entity.startAt = d;
  }

  get callEndTime(): string {
    if (!this.entity.endAt) return '10:00';
    const d = new Date(this.entity.endAt);
    return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
  }

  set callEndTime(val: string) {
    if (!val) return;
    const parts = val.split(':');
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const baseDate = this.entity.startAt ? new Date(this.entity.startAt) : new Date();
    const d = new Date(baseDate);
    d.setHours(hours, minutes, 0, 0);
    this.entity.endAt = d;
  }

  getTypeColorByType(type: ActivityType): string {
    switch (type) {
      case ActivityType.Note: return 'grey';
      case ActivityType.Task: return 'orange';
      case ActivityType.Call: return 'green';
      case ActivityType.Meeting: return 'purple';
      case ActivityType.Email: return 'blue';
      default: return 'grey';
    }
  }

  getUserAvatarUrl(userId: string, avatar: string): string {
    if (!avatar) return '';
    return AppModule.currentAgencyContext.storageSharedBaseUrl + '/avatars/2/' + userId + '/resized-100/' + avatar;
  }

  async loadEmailBody() {
    if (!this.activity || !this.isEmail || !this.activity.emailBodyStoragePath) {
      this.emailBodyHtml = '';
      return;
    }

    this.loadingEmailBody = true;
    try {
      const response = await ajax.get(`/api/v1/agency/activities/emails/${this.activity.id}/body?content=true`);
      this.emailBodyHtml = response.data.content || '';
    } catch (error) {
      this.emailBodyHtml = '';
    } finally {
      this.loadingEmailBody = false;
    }
  }

  resizeIframe() {
    const iframe = this.$refs.emailIframe as HTMLIFrameElement;
    if (!iframe || !iframe.contentDocument || !iframe.contentDocument.body) return;
    const body = iframe.contentDocument.body;
    const measure = () => {
      // Clamp to a minimum: scrollHeight can read 0 when @load fires before the
      // srcdoc content has laid out (common for short bodies like a single <p>),
      // which would otherwise collapse the frame and hide the email entirely.
      iframe.style.height = Math.max(body.scrollHeight + 20, 60) + 'px';
    };
    measure();
    requestAnimationFrame(measure);
  }

  created() {
    this.debouncedEntitySearch = debounce(this.searchEntities, 300);
  }

  async searchEntities() {
    if (!this.selectedEntityType || !this.entitySearchQuery || this.entitySearchQuery.length < 2) {
      this.entitySearchResults = [];
      return;
    }

    this.entitySearchLoading = true;
    try {
      const typeMap: { [key: number]: string } = {
        [ActivityEntityType.Contact]: 'contact',
        [ActivityEntityType.Company]: 'company',
        [ActivityEntityType.Location]: 'location',
        [ActivityEntityType.Worker]: 'worker',
        [ActivityEntityType.Job]: 'job',
        [ActivityEntityType.Opportunity]: 'opportunity',
      };

      const entityTypeName = typeMap[this.selectedEntityType];
      if (!entityTypeName) {
        this.entitySearchResults = [];
        return;
      }

      const response = await ajax.get(
        `/api/v1/agency/quick-search?type=${entityTypeName}&q=${encodeURIComponent(this.entitySearchQuery)}`
      );

      this.entitySearchResults = (response.data.results || []).map((r: any) => ({
        id: r.id,
        name: r.name,
        subtitle: r.subtitle || '',
        type: this.selectedEntityType
      }));
    } catch (error) {
      // Silent fail for search
      this.entitySearchResults = [];
    } finally {
      this.entitySearchLoading = false;
    }
  }

  onEntityTypeChanged() {
    // Reset entity selection when type changes
    this.selectedEntity = null;
    this.entitySearchQuery = '';
    this.entitySearchResults = [];
    // Clear the entity data
    this.entity.primaryEntityType = this.selectedEntityType;
    this.entity.contactId = null;
    this.entity.companyId = null;
    this.entity.locationId = null;
    this.entity.workerId = null;
    this.entity.jobId = null;
    this.entity.bookingId = null;
    this.entity.opportunityId = null;
    // Clear category when entity type changes (filtered categories will change)
    this.entity.categoryId = null;
    // Clear email options when entity type changes
    this.availableEmailOptions = [];
    // Clear location-contact options — refilled if/when a Location is picked
    this.locationContacts = [];
    // If only one category is now valid for the new entity type, pre-select it
    this.autoSelectSingleCategory();
  }

  async loadEmailOptionsForEntity() {
    // Only load for email activities
    if (!this.editIsEmail) {
      this.availableEmailOptions = [];
      return;
    }

    // For Company or Location, load contacts and surface the entity's own
    // main email as a labelled dropdown option (not auto-filled into To:).
    if (this.createEntityType === ActivityEntityType.Company && this.createEntityId) {
      await this.loadContactsForCompany(this.createEntityId);
      this.appendMainEmailOption(this.createEntityEmail, 'Company main email');
    } else if (this.createEntityType === ActivityEntityType.Location && this.createEntityId) {
      await this.loadContactsForLocation(this.createEntityId);
      this.appendMainEmailOption(this.createEntityEmail, 'Location main email');
    } else if (this.createEntityType === ActivityEntityType.Contact && this.createEntityEmail) {
      // For Contact, add their email as the only option and pre-select
      this.availableEmailOptions = [{ email: this.createEntityEmail, name: 'Contact' }];
    } else if (this.createEntityType === ActivityEntityType.Worker && this.createEntityEmail) {
      // For Worker, add their email as the only option and pre-select
      this.availableEmailOptions = [{ email: this.createEntityEmail, name: 'Worker' }];
    } else if (this.createEntityType === ActivityEntityType.Opportunity && this.createEntityOpportunity) {
      // For Opportunity, expose every email source from the linked records
      // and the prospect snapshot, labelled by source so the user can pick.
      this.availableEmailOptions = this.buildOpportunityRecipients()
          .filter(r => !!r.email)
          .map(r => ({ email: r.email, name: r.label }));
    } else {
      this.availableEmailOptions = [];
    }
  }

  /**
   * Resolves the master list of recipient candidates for an opportunity in
   * priority order (Contact > Location > Company; linked > prospect within
   * each layer). Returns one entry per (layer, channel) pair; channels are
   * 'email' (string) and 'phone' (string) — only one set per entry.
   *
   * Used by both the email options dropdown and the call-phone picker.
   */
  buildOpportunityRecipients(): { source: string; label: string; email: string; phone: string }[] {
    const opp = this.createEntityOpportunity;
    if (!opp) return [];
    const out: { source: string; label: string; email: string; phone: string }[] = [];

    const contactName = (opp.contact && opp.contact.person)
        ? `${opp.contact.person.firstName || ''} ${opp.contact.person.lastName || ''}`.trim()
        : '';
    const prospectContactName = `${opp.prospectContactFirstName || ''} ${opp.prospectContactLastName || ''}`.trim();
    const locationName = opp.location ? opp.location.brandName : opp.prospectLocationName || 'Location';
    const companyName = opp.company ? opp.company.brandName : opp.prospectCompanyName || 'Company';

    // Contact layer (most specific) — linked first, prospect second
    if (opp.contact) {
      if (opp.contact.mobilePhoneNumber) {
        out.push({ source: 'contact-mobile', label: `${contactName || 'Contact'} — mobile`, email: '', phone: opp.contact.mobilePhoneNumber });
      }
      if (opp.contact.otherPhoneNumber) {
        out.push({ source: 'contact-other', label: `${contactName || 'Contact'} — other`, email: '', phone: opp.contact.otherPhoneNumber });
      }
      if (opp.contact.emailAddress) {
        out.push({ source: 'contact-email', label: contactName || 'Contact', email: opp.contact.emailAddress, phone: '' });
      }
    }
    if (opp.prospectContactMobilePhoneNumber) {
      out.push({ source: 'prospect-contact-mobile', label: `${prospectContactName || 'Prospect contact'} — mobile`, email: '', phone: opp.prospectContactMobilePhoneNumber });
    }
    if (opp.prospectContactOtherPhoneNumber) {
      out.push({ source: 'prospect-contact-other', label: `${prospectContactName || 'Prospect contact'} — other`, email: '', phone: opp.prospectContactOtherPhoneNumber });
    }
    if (opp.prospectContactEmail) {
      out.push({ source: 'prospect-contact-email', label: prospectContactName || 'Prospect contact', email: opp.prospectContactEmail, phone: '' });
    }

    // Location layer — linked first, prospect second
    if (opp.location) {
      if (opp.location.emailAddress) {
        out.push({ source: 'location-email', label: `${locationName} (location)`, email: opp.location.emailAddress, phone: '' });
      }
      if (opp.location.phoneNumber) {
        out.push({ source: 'location-phone', label: `${locationName} (location)`, email: '', phone: opp.location.phoneNumber });
      }
    }
    if (opp.prospectLocationEmail) {
      out.push({ source: 'prospect-location-email', label: `${locationName} (prospect location)`, email: opp.prospectLocationEmail, phone: '' });
    }
    if (opp.prospectLocationPhone) {
      out.push({ source: 'prospect-location-phone', label: `${locationName} (prospect location)`, email: '', phone: opp.prospectLocationPhone });
    }

    // Company layer — linked first, prospect second
    if (opp.company) {
      if (opp.company.emailAddress) {
        out.push({ source: 'company-email', label: `${companyName} (company)`, email: opp.company.emailAddress, phone: '' });
      }
      if (opp.company.phoneNumber) {
        out.push({ source: 'company-phone', label: `${companyName} (company)`, email: '', phone: opp.company.phoneNumber });
      }
    }
    if (opp.prospectCompanyEmail) {
      out.push({ source: 'prospect-company-email', label: `${companyName} (prospect company)`, email: opp.prospectCompanyEmail, phone: '' });
    }
    if (opp.prospectCompanyPhone) {
      out.push({ source: 'prospect-company-phone', label: `${companyName} (prospect company)`, email: '', phone: opp.prospectCompanyPhone });
    }

    return out;
  }

  /**
   * Pre-fills entity.emailToAddresses / entity.phoneNumber / entity.meetingLocation
   * with the most-specific available source from the opportunity. Called from
   * initializeNewEntity once the entity object is built.
   */
  applyOpportunityRecipientPrefill() {
    const opp = this.createEntityOpportunity;
    if (!opp) return;
    const recipients = this.buildOpportunityRecipients();

    // Email To — use the first contact-layer email if present.
    if (this.editIsEmail) {
      const firstEmail = recipients.find(r => r.email && r.source.indexOf('contact-') === 0);
      if (firstEmail && (!this.entity.emailToAddresses || this.entity.emailToAddresses.length === 0)) {
        this.entity.emailToAddresses = [firstEmail.email];
      }
    }

    // Call phone — use the first contact-layer phone if present.
    if (this.editIsCall) {
      const firstPhone = recipients.find(r => r.phone && r.source.indexOf('contact-') === 0);
      if (firstPhone && !this.entity.phoneNumber) {
        this.entity.phoneNumber = firstPhone.phone;
      }
    }

    // Meeting location — formatted address from linked location > prospect location.
    if (this.editIsMeeting && !this.entity.meetingLocation) {
      if (opp.location) {
        const parts = [
          opp.location.buildingNameNumber,
          opp.location.streetRoadBlock,
          opp.location.cityTown,
          opp.location.stateProvinceRegion,
          opp.location.postZipCode,
        ].filter((p: string) => !!p);
        this.entity.meetingLocation = parts.join(', ');
      } else if (opp.prospectLocationAddress1 || opp.prospectLocationCity) {
        const parts = [
          opp.prospectLocationAddress1,
          opp.prospectLocationAddress2,
          opp.prospectLocationCity,
          opp.prospectLocationRegion,
          opp.prospectLocationPostcode,
          opp.prospectLocationCountry,
        ].filter((p: string) => !!p);
        this.entity.meetingLocation = parts.join(', ');
      }
    }
  }

  /**
   * Appends a "main email" option for an entity (Location/Company) without
   * duplicating an entry that's already present (e.g. one of the contacts
   * happens to share the same address).
   */
  appendMainEmailOption(email: string | null | undefined, label: string) {
    if (!email) return;
    const lower = email.toLowerCase();
    const exists = this.availableEmailOptions.some(o => o.email.toLowerCase() === lower);
    if (!exists) {
      this.availableEmailOptions.push({ email, name: label });
    }
  }

  async loadContactsForCompany(companyId: string) {
    this.loadingEmailOptions = true;
    try {
      const response = await ajax.get(`/api/v1/agency/companies/${companyId}/contacts`);
      const contacts = response.data || [];
      this.availableEmailOptions = contacts
        .filter((c: any) => c.emailAddress)
        .map((c: any) => ({
          email: c.emailAddress,
          name: c.person ? `${c.person.firstName} ${c.person.lastName}` : c.emailAddress,
          contactId: c.id
        }));
    } catch (error) {
      // Silent fail - just leave options empty
      this.availableEmailOptions = [];
    } finally {
      this.loadingEmailOptions = false;
    }
  }

  async loadContactsForLocation(locationId: string) {
    this.loadingEmailOptions = true;
    try {
      const response = await ajax.get(`/api/v1/agency/locations/${locationId}/contacts`);
      const contactLocations = response.data || [];
      // Extract contacts from contact locations
      this.availableEmailOptions = contactLocations
        .filter((cl: any) => cl.contact && cl.contact.emailAddress)
        .map((cl: any) => ({
          email: cl.contact.emailAddress,
          name: cl.contact.person ? `${cl.contact.person.firstName} ${cl.contact.person.lastName}` : cl.contact.emailAddress,
          contactId: cl.contact.id
        }));
    } catch (error) {
      // Silent fail - just leave options empty
      this.availableEmailOptions = [];
    } finally {
      this.loadingEmailOptions = false;
    }
  }

  async onEntitySelected(entity: any) {
    if (!entity) {
      this.selectedEntity = null;
      // Clear the entity data when selection is cleared
      this.entity.primaryEntityType = null;
      this.entity.primaryEntityName = null;
      this.entity.contactId = null;
      this.entity.companyId = null;
      this.entity.locationId = null;
      this.entity.workerId = null;
      this.entity.jobId = null;
      this.entity.bookingId = null;
      this.entity.opportunityId = null;
      this.locationContacts = [];
      // Clear email fields
      if (this.editIsEmail) {
        this.entity.emailToAddresses = [];
        this.availableEmailOptions = [];
      }
      return;
    }
    this.selectedEntity = entity;
    // Update the entity data for save
    this.entity.primaryEntityType = entity.type;
    this.entity.primaryEntityName = entity.name;
    this.entity.contactId = entity.type === ActivityEntityType.Contact ? entity.id : null;
    this.entity.companyId = entity.type === ActivityEntityType.Company ? entity.id : null;
    this.entity.locationId = entity.type === ActivityEntityType.Location ? entity.id : null;
    this.entity.workerId = entity.type === ActivityEntityType.Worker ? entity.id : null;
    this.entity.jobId = entity.type === ActivityEntityType.Job ? entity.id : null;
    this.entity.bookingId = entity.type === ActivityEntityType.Booking ? entity.id : null;
    this.entity.opportunityId = entity.type === ActivityEntityType.Opportunity ? entity.id : null;

    // For Location-scoped activities, load the linked contacts so the user
    // can optionally attach one to the activity.
    if (entity.type === ActivityEntityType.Location) {
      this.loadLocationContacts(entity.id);
    } else {
      this.locationContacts = [];
    }

    // For email activities, handle different entity types
    if (this.editIsEmail) {
      if (entity.type === ActivityEntityType.Company) {
        // Load contacts for the selected company, then surface the company's
        // own main email as a labelled option (the picker only knows id/name).
        await this.loadContactsForCompany(entity.id);
        try {
          const resp = await ajax.get(`/api/v1/agency/companies/${entity.id}`);
          this.appendMainEmailOption(resp.data?.emailAddress, 'Company main email');
        } catch {
          // Silent — leave options as loaded
        }
        this.entity.emailToAddresses = [];
      } else if (entity.type === ActivityEntityType.Location) {
        // Same pattern as Company: contacts first, then append the location's
        // own main email if it has one.
        await this.loadContactsForLocation(entity.id);
        try {
          const resp = await ajax.get(`/api/v1/agency/locations/${entity.id}`);
          this.appendMainEmailOption(resp.data?.emailAddress, 'Location main email');
        } catch {
          // Silent — leave options as loaded
        }
        this.entity.emailToAddresses = [];
      } else if (entity.type === ActivityEntityType.Contact || entity.type === ActivityEntityType.Worker) {
        // For Contact/Worker, pre-populate To address from subtitle (email)
        if (entity.subtitle && this.isValidEmail(entity.subtitle)) {
          this.availableEmailOptions = [{ email: entity.subtitle, name: entity.name }];
          this.entity.emailToAddresses = [entity.subtitle];
        } else {
          this.availableEmailOptions = [];
          this.entity.emailToAddresses = [];
        }
      } else {
        this.availableEmailOptions = [];
      }

    }
  }

  isValidEmail(email: string): boolean {
    // Simple email validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  @Watch('visible', { immediate: true })
  async onVisibleChanged(val: boolean) {
    if (val) {
      // Load categories, users, and branches if needed
      if (this.categories.length === 0) {
        await this.loadCategories();
      }
      if (AgencySettingsModule.agencyUsers.length === 0) {
        await AgencySettingsModule.getAgencyUsers();
      }
      if (AgencySettingsModule.branches.length === 0) {
        await AgencySettingsModule.getBranches();
      }

      // Use nextTick to ensure all props are updated before checking createMode
      this.$nextTick(() => {
        if (this.createMode && this.createActivityType !== null) {
          this.isEditing = true;
          this.initializeNewEntityOnce();
        } else if (!this.createMode && this.activity) {
          // Go straight into edit mode
          this.startEditing();
        }
      });
    } else {
      this.isEditing = false;
      this.lastInitKey = null;
    }
  }

  @Watch('createMode')
  onCreateModeChanged(val: boolean) {
    if (val && this.visible && this.createActivityType !== null) {
      this.isEditing = true;
      this.initializeNewEntityOnce();
    }
  }

  @Watch('createActivityType')
  onCreateActivityTypeChanged(val: ActivityType | null) {
    // If we're in create mode and the activity type changes, reinitialize
    if (this.createMode && this.visible && val !== null) {
      this.initializeNewEntityOnce();
    }
  }

  @Watch('activity')
  onActivityChanged() {
    this.emailBodyHtml = '';
    if (this.activity && this.isEmail && !this.isEditing) {
      this.loadEmailBody();
    }
  }

  @Watch('entitySearchQuery')
  onEntitySearchQueryChanged() {
    if (this.debouncedEntitySearch) {
      this.debouncedEntitySearch();
    }
  }

  @Watch('filteredCategories')
  onFilteredCategoriesChanged() {
    this.autoSelectSingleCategory();
  }

  async loadCategories() {
    this.loadingCategories = true;
    try {
      const response = await ajax.get('/api/v1/agency/activity-categories');
      this.categories = response.data || [];
    } catch (error) {
      // Silent fail - categories are optional
      this.categories = [];
    } finally {
      this.loadingCategories = false;
    }
  }

  /**
   * Identifies what the panel is being opened to create. Opening the panel
   * changes `visible`, `createMode` and `createActivityType` in one tick, so
   * all three watchers above fire in the same flush for a single open — this
   * key lets the second and third calls recognise they have nothing to do.
   */
  buildInitKey(): string {
    return [
      this.createMode ? '1' : '0',
      this.createActivityType === null ? '' : String(this.createActivityType),
      this.createActivityDirection === null ? '' : String(this.createActivityDirection),
      this.createEntityType === null ? '' : String(this.createEntityType),
      this.createEntityId || '',
      this.createFromActivity ? this.createFromActivity.id : '',
      this.replyToActivity ? this.replyToActivity.id : '',
      this.replyAll ? '1' : '0',
      this.chase ? '1' : '0'
    ].join('|');
  }

  /**
   * Initialises the create panel at most once per configuration. For email
   * activities initializeNewEntity() POSTs a draft, so running it three times
   * for one open of the panel left two orphaned drafts on the timeline.
   * A genuine change of activity type while the panel is open produces a new
   * key and still re-initialises.
   */
  async initializeNewEntityOnce() {
    const key = this.buildInitKey();
    if (key === this.lastInitKey) {
      return;
    }
    this.lastInitKey = key;
    await this.initializeNewEntity();
  }

  async initializeNewEntity() {
    // Reset entity picker state
    this.selectedEntityType = null;
    this.selectedEntity = null;
    this.entitySearchQuery = '';
    this.callDurationMinutes = 5;
    this.entitySearchResults = [];

    // Default owner to current user for all activity types
    const currentUserId = AppModule.userProfile?.agencyUserId || null;
    const defaultOwner = currentUserId
      ? AgencySettingsModule.agencyUsers.find(u => u.id === currentUserId) || null
      : null;

    // Default due date (endAt) for tasks: tomorrow at 9 AM
    const defaultEndAt = new Date();
    defaultEndAt.setDate(defaultEndAt.getDate() + 1);
    defaultEndAt.setHours(9, 0, 0, 0);

    // Determine activity type flags
    const isEmailActivity = this.createActivityType === ActivityType.Email;
    const isTaskActivity = this.createActivityType === ActivityType.Task;
    const isMeeting = this.createActivityType === ActivityType.Meeting;

    // Pre-populate To address for emails when the entity's own email IS the
    // natural recipient (Contact/Worker). For Company/Location the main email
    // is offered in the dropdown instead — see loadEmailOptionsForEntity.
    const emailToAddresses: string[] = [];
    const prefillFromEntity =
      this.createEntityType === ActivityEntityType.Contact ||
      this.createEntityType === ActivityEntityType.Worker;
    if (isEmailActivity && this.createEntityEmail && prefillFromEntity) {
      emailToAddresses.push(this.createEntityEmail);
    }

    // Set default status based on type:
    // - Tasks: Planned (can be scheduled for future)
    // - Notes, Calls, Meetings, Emails: Completed (historical records)
    const defaultStatus = isTaskActivity ? ActivityStatus.Planned : ActivityStatus.Completed;

    // Pre-populate direction for Calls and Emails
    // For Calls: use provided direction or null (user must select)
    // For Emails: default to Outbound if not provided
    const isCallActivity = this.createActivityType === ActivityType.Call;
    let defaultDirection = null;
    if (isCallActivity && this.createActivityDirection !== null) {
      defaultDirection = this.createActivityDirection;
    } else if (isEmailActivity) {
      defaultDirection = this.createActivityDirection !== null
        ? this.createActivityDirection
        : ActivityDirection.Outbound;
    }

    // Pre-populate from source activity if creating from another activity
    let subject = '';
    let categoryId: string | null = null;
    let branchId = AppModule.userProfile?.defaultBranchId || null;
    let deskId = AppModule.userProfile?.defaultDeskId || null;
    let primaryEntityType = this.createEntityType;
    let contactId: string | null = null;
    let workerId: string | null = null;
    let companyId: string | null = null;
    let locationId: string | null = null;
    let jobId: string | null = null;
    let bookingId: string | null = null;
    let opportunityId: string | null = null;
    let createdFromActivityId: string | null = null;

    if (this.createFromActivity) {
      const sourceActivity = this.createFromActivity;

      // Copy subject from source activity
      subject = sourceActivity.subject || '';

      // Copy branch and desk
      branchId = sourceActivity.branchId || branchId;
      deskId = sourceActivity.deskId || deskId;

      // Copy entity context — every FK the source can carry. Missing one
      // here breaks follow-up creation for that entity type: primaryEntityType
      // copies across but getPrimaryEntityId() then resolves null and the
      // backend rejects the create (this is exactly how opportunity
      // follow-ups were broken).
      primaryEntityType = sourceActivity.primaryEntityType;
      contactId = sourceActivity.contactId;
      workerId = sourceActivity.workerId;
      companyId = sourceActivity.companyId;
      locationId = sourceActivity.locationId;
      jobId = sourceActivity.jobId;
      bookingId = sourceActivity.bookingId;
      opportunityId = sourceActivity.opportunityId;

      // Set the link to source activity
      createdFromActivityId = sourceActivity.id;

      // Pre-populate entity picker when creating from main list (no entity context)
      if (this.showEntityPicker && sourceActivity.primaryEntityType && sourceActivity.primaryEntityId) {
        this.selectedEntityType = sourceActivity.primaryEntityType;
        const entityObj = {
          id: sourceActivity.primaryEntityId,
          name: sourceActivity.primaryEntityName || '',
          subtitle: '',
          type: sourceActivity.primaryEntityType
        };
        this.selectedEntity = entityObj;
        this.entitySearchResults = [entityObj];
      }

      // Check if source category is valid for tasks on this entity type
      if (isTaskActivity && sourceActivity.categoryId) {
        const sourceCategory = this.categories.find(c => c.id === sourceActivity.categoryId);
        if (sourceCategory && this.isCategoryEnabledFor(sourceCategory, primaryEntityType, ActivityType.Task)) {
          categoryId = sourceActivity.categoryId;
        }
        // If category is not valid for tasks, leave it null so user must select
      }
    }

    this.entity = {
      type: this.createActivityType,
      status: defaultStatus,
      subject: subject,
      body: '',
      categoryId: categoryId,
      owner: defaultOwner,
      startAt: (isMeeting || isCallActivity) ? new Date() : null,
      endAt: isTaskActivity ? defaultEndAt : null,
      taskPriority: 2, // Normal
      direction: defaultDirection,
      phoneNumber: '',
      callOutcome: null,
      meetingLocation: '',
      meetingOnlineUrl: '',
      meetingIsOnline: false,
      // Email fields
      emailToAddresses: emailToAddresses,
      emailCcAddresses: [],
      emailBccAddresses: [],
      emailFromAddress: '',
      emailFromName: '',
      // Branch and Desk
      branchId: branchId,
      deskId: deskId,
      // Entity context
      primaryEntityType: primaryEntityType,
      primaryEntityName: null,
      contactId: contactId,
      workerId: workerId,
      companyId: companyId,
      locationId: locationId,
      jobId: jobId,
      bookingId: bookingId,
      opportunityId: opportunityId,
      // Link to source activity
      createdFromActivityId: createdFromActivityId
    };

    // Set the appropriate entity ID based on type (only if not already set from createFromActivity)
    if (!this.createFromActivity && this.createEntityType && this.createEntityId) {
      switch (this.createEntityType) {
        case ActivityEntityType.Contact:
          this.entity.contactId = this.createEntityId;
          break;
        case ActivityEntityType.Worker:
          this.entity.workerId = this.createEntityId;
          break;
        case ActivityEntityType.Company:
          this.entity.companyId = this.createEntityId;
          break;
        case ActivityEntityType.Location:
          this.entity.locationId = this.createEntityId;
          break;
        case ActivityEntityType.Job:
          this.entity.jobId = this.createEntityId;
          break;
        case ActivityEntityType.Booking:
          this.entity.bookingId = this.createEntityId;
          break;
        case ActivityEntityType.Opportunity:
          this.entity.opportunityId = this.createEntityId;
          // Cascade the opportunity's linked-record FKs onto the activity.
          // The backend's populateRelatedEntityFKs would do this server-side
          // anyway, but having them on the client keeps recipient pre-fill
          // calculations and timeline UI consistent without a re-fetch.
          if (this.createEntityOpportunity) {
            this.entity.companyId = this.createEntityOpportunity.companyId || null;
            this.entity.locationId = this.createEntityOpportunity.locationId || null;
            this.entity.contactId = this.createEntityOpportunity.contactId || null;
          }
          break;
      }
    }

    // For Opportunity-scoped activities, pre-fill recipient fields (email To,
    // call phone, meeting location) from the most-specific available source
    // across the opportunity's linked records and prospect snapshot.
    if (this.createEntityType === ActivityEntityType.Opportunity && this.createEntityOpportunity) {
      this.applyOpportunityRecipientPrefill();
    }

    this.autoSelectSingleCategory();

    // For Location-scoped activities, load the linked contacts so the user
    // can optionally attach one. Loader runs async — UI handles loading state.
    if (this.currentLocationId) {
      this.loadLocationContacts(this.currentLocationId);
    } else {
      this.locationContacts = [];
    }

    // Load email options for the entity (contacts for company/location)
    if (isEmailActivity) {
      this.draftActivityId = null;
      this.draftUpdatedAt = null;
      this.draftAttachments = [];
      if (this.replyToActivity) {
        await this.initializeReplyEmail();
      } else {
        this.loadEmailOptionsForEntity();
        await this.loadEmailSignature();
      }
      this.activateEmailEditor();
      // Create draft immediately if we already have entity context (from entity page or reply).
      // When using the entity picker (central view), draft is created after entity selection.
      if (!this.showEntityPicker) {
        await this.createEmailDraft();
      }
    }
  }

  async loadEmailSignature() {
    try {
      const response = await ajax.get('/api/v1/agency/users/profile/mailbox/status');
      const status: MailboxStatusResponse = response.data;
      if (status.connected && status.isSignatureEnabled && status.signatureHtml) {
        this.entity.body = '<br/><div class="email-signature">' + status.signatureHtml + '</div>';
      }
    } catch {
      // No mailbox connected or error — leave body empty
    }
  }

  async initializeReplyEmail() {
    const original = this.replyToActivity!;

    // Override entity context with original activity's context
    this.entity.primaryEntityType = original.primaryEntityType;
    this.entity.contactId = original.contactId;
    this.entity.workerId = original.workerId;
    this.entity.companyId = original.companyId;
    this.entity.locationId = original.locationId;
    this.entity.jobId = original.jobId;
    this.entity.bookingId = original.bookingId;

    // Copy category from original
    if (original.categoryId) {
      this.entity.categoryId = original.categoryId;
    }

    // Inherit branch/desk from original
    if (original.branchId) {
      this.entity.branchId = original.branchId;
    }
    if (original.deskId) {
      this.entity.deskId = original.deskId;
    }

    // Set replied-to activity ID
    this.entity.repliedToActivityId = original.id;

    // Pre-populate subject with "Re: " prefix
    const originalSubject = original.subject || '';
    if (originalSubject.toLowerCase().startsWith('re:')) {
      this.entity.subject = originalSubject;
    } else {
      this.entity.subject = `Re: ${originalSubject}`;
    }

    // Load mailbox status (need provider email for self-exclusion + signature)
    try {
      const response = await ajax.get('/api/v1/agency/users/profile/mailbox/status');
      this.mailboxStatus = response.data;
    } catch {
      this.mailboxStatus = null;
    }

    const currentUserEmail = this.mailboxStatus?.providerEmail?.toLowerCase() || '';

    // Pre-populate recipients
    if (this.chase) {
      // Chase: keep the same recipients from the outbound email
      if (original.emailToAddresses) {
        this.entity.emailToAddresses = [...original.emailToAddresses];
      }
      if (original.emailCcAddresses && original.emailCcAddresses.length > 0) {
        this.entity.emailCcAddresses = [...original.emailCcAddresses];
      }
    } else if (this.replyAll) {
      // Reply All: sender + all original To + CC (excluding self)
      const toRecipients: string[] = [];
      const ccRecipients: string[] = [];

      // Add original sender to To
      if (original.emailFromAddress) {
        toRecipients.push(original.emailFromAddress);
      }

      // Add original To recipients (excluding self)
      if (original.emailToAddresses) {
        for (const email of original.emailToAddresses) {
          if (email.toLowerCase() !== currentUserEmail) {
            toRecipients.push(email);
          }
        }
      }

      // Add original CC recipients (excluding self)
      if (original.emailCcAddresses) {
        for (const email of original.emailCcAddresses) {
          if (email.toLowerCase() !== currentUserEmail) {
            ccRecipients.push(email);
          }
        }
      }

      this.entity.emailToAddresses = toRecipients;
      this.entity.emailCcAddresses = ccRecipients;
    } else {
      // Reply: only original sender
      if (original.emailFromAddress) {
        this.entity.emailToAddresses = [original.emailFromAddress];
      }
    }

    // Fetch original email body and create quoted text
    let originalBodyHtml = '';
    if (original.emailBodyStoragePath) {
      try {
        const response = await ajax.get(`/api/v1/agency/activities/emails/${original.id}/body?content=true`);
        originalBodyHtml = response.data.content || '';
      } catch {
        originalBodyHtml = original.body || '';
      }
    } else {
      originalBodyHtml = original.body || '';
    }

    // Build body: signature + quoted text
    let body = '';
    if (this.mailboxStatus && this.mailboxStatus.connected && this.mailboxStatus.isSignatureEnabled && this.mailboxStatus.signatureHtml) {
      body += '<br/><div class="email-signature">' + this.mailboxStatus.signatureHtml + '</div>';
    }
    body += '<br><br>' + this.formatQuotedEmail(original, originalBodyHtml);
    this.entity.body = body;

    // Pre-populate entity picker for main list view (Activities page)
    if (this.showEntityPicker && original.primaryEntityType && original.primaryEntityId) {
      this.selectedEntityType = original.primaryEntityType;
      const entityObj = {
        id: original.primaryEntityId,
        name: original.primaryEntityName || '',
        subtitle: '',
        type: original.primaryEntityType
      };
      this.selectedEntity = entityObj;
      this.entitySearchResults = [entityObj];
    }

    this.autoSelectSingleCategory();
  }

  formatQuotedEmail(original: ActivityDto, bodyHtml: string): string {
    const dateStr = original.createdAt
      ? new Date(original.createdAt).toLocaleString('en-GB', {
          weekday: 'short',
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      : '';

    const senderName = original.emailFromName || '';
    const senderEmail = original.emailFromAddress || '';
    const senderDisplay = senderName
      ? `${senderName} &lt;${senderEmail}&gt;`
      : senderEmail;

    return `<div style="border-left: 2px solid #ccc; padding-left: 10px; margin-left: 5px; color: #666;">
      <p style="margin: 0 0 10px 0;">On ${dateStr}, ${senderDisplay} wrote:</p>
      ${bodyHtml}
    </div>`;
  }

  activateEmailEditor() {
    this.editorReady = false;
    this.editorKey++;
    this.$nextTick(() => {
      this.editorReady = true;
    });
  }

  populateEntityFromActivity() {
    if (!this.activity) return;
    // Find the owner in the agency users list
    const owner = this.activity.ownerId
      ? AgencySettingsModule.agencyUsers.find(u => u.id === this.activity!.ownerId) || null
      : null;

    this.entity = {
      status: this.activity.status,
      subject: this.activity.subject,
      body: this.activity.body,
      categoryId: this.activity.categoryId,
      branchId: this.activity.branchId,
      deskId: this.activity.deskId,
      owner: owner,
      startAt: this.activity.startAt,
      endAt: this.activity.endAt,
      taskPriority: this.activity.taskPriority,
      direction: this.activity.direction,
      phoneNumber: this.activity.phoneNumber,
      callOutcome: this.activity.callOutcome,
      meetingLocation: this.activity.meetingLocation,
      meetingOnlineUrl: this.activity.meetingOnlineUrl,
      meetingIsOnline: this.activity.meetingIsOnline || false,
      // Email fields
      emailFromAddress: this.activity.emailFromAddress,
      emailFromName: this.activity.emailFromName,
      emailToAddresses: this.activity.emailToAddresses || [],
      emailCcAddresses: this.activity.emailCcAddresses || [],
      emailBccAddresses: this.activity.emailBccAddresses || [],
      updatedAt: this.activity.updatedAt
    };
  }

  startEditing() {
    this.populateEntityFromActivity();
    this.isEditing = true;

    // Draft outbound email: populate draft state and load body for editing
    if (this.editIsEmail && this.isDraftActivity && this.activity?.direction === ActivityDirection.Outbound) {
      this.draftActivityId = this.activity.id;
      this.draftUpdatedAt = this.activity.updatedAt ? new Date(this.activity.updatedAt) : null;
      this.draftAttachments = this.activity.attachments || [];
      this.loadDraftEmailBody();
      this.activateEmailEditor();
    } else if (this.editIsEmail && this.createMode) {
      this.activateEmailEditor();
    } else if (this.editIsEmail && !this.createMode) {
      this.loadEmailBody();
    }
  }

  /**
   * Loads the email body HTML from GCS and sets it on the entity for editing.
   */
  async loadDraftEmailBody() {
    if (!this.activity || !this.activity.emailBodyStoragePath) return;
    try {
      const response = await ajax.get(`/api/v1/agency/activities/emails/${this.activity.id}/body?content=true`);
      this.entity.body = response.data.content || '';
    } catch {
      // Leave body as-is from the activity
    }
  }

  cancelEditing() {
    this.editorReady = false;
    this.isEditing = false;
    this.resetDraftState();
    this.$emit('close');
  }

  handleClose() {
    this.editorReady = false;
    this.isEditing = false;
    this.resetDraftState();
    this.$emit('close');
  }

  resetDraftState() {
    this.draftActivityId = null;
    this.draftUpdatedAt = null;
    this.draftAttachments = [];
    this.draftSaving = false;
    this.draftSending = false;
    this.draftCreateRequest = null;
    this.mailboxStatus = null;
    this.lastInitKey = null;
  }

  onAttachmentActivityUpdated(updatedAt: string) {
    this.draftUpdatedAt = new Date(updatedAt);
  }

  async onEnsureDraft() {
    if (!this.draftActivityId) {
      await this.createEmailDraft();
    }
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    this.saving = true;
    try {
      if (this.createMode) {
        // Ensure we have a valid activity type from the prop
        const activityType = this.createActivityType;
        if (activityType === null || activityType === undefined) {
          console.error('ActivitySidePanel: createActivityType is null/undefined when saving');
          return;
        }

        // Build shared fields
        const shared: any = {
          categoryId: this.entity.categoryId || null,
          branchId: this.entity.branchId || null,
          deskId: this.entity.deskId || null,
          createdFromActivityId: this.entity.createdFromActivityId || null
        };

        // Add entity context if provided
        if (this.entity.primaryEntityType) {
          shared.primaryEntityType = this.entity.primaryEntityType;
          shared.primaryEntityId = this.getPrimaryEntityId();
        }

        // For Location-scoped activities, include any chosen contact link.
        // For Contact-primary activities the backend derives contactId itself,
        // so only forward it when the primary entity is a Location.
        if (this.entity.primaryEntityType === ActivityEntityType.Location && this.entity.contactId) {
          shared.contactId = this.entity.contactId;
        }

        // Call the type-specific endpoint
        if (activityType === ActivityType.Note) {
          await ajax.post('/api/v1/agency/activities/notes', {
            ...shared,
            body: this.entity.body || ''
          });
        } else if (activityType === ActivityType.Task) {
          const request: any = {
            ...shared,
            subject: this.entity.subject,
            body: this.entity.body || '',
            ownerId: this.entity.owner?.id || null,
            status: this.entity.status,
            taskPriority: this.entity.taskPriority
          };
          if (this.entity.endAt) {
            const endDate = this.entity.endAt instanceof Date
              ? this.entity.endAt
              : new Date(this.entity.endAt);
            request.endAt = endDate.toISOString();
          }
          await ajax.post('/api/v1/agency/activities/tasks', request);
        } else if (activityType === ActivityType.Call) {
          const request: any = {
            ...shared,
            subject: this.entity.subject,
            body: this.entity.body || '',
            direction: this.entity.direction,
            phoneNumber: this.entity.phoneNumber || '',
            callOutcome: this.entity.callOutcome
          };
          if (this.entity.startAt) {
            const startDate = this.entity.startAt instanceof Date ? this.entity.startAt : new Date(this.entity.startAt);
            request.startAt = startDate.toISOString();
            const endDate = new Date(startDate.getTime() + this.callDurationMinutes * 60000);
            request.endAt = endDate.toISOString();
          }
          await ajax.post('/api/v1/agency/activities/calls', request);
        } else if (activityType === ActivityType.Meeting) {
          const request: any = {
            ...shared,
            subject: this.entity.subject,
            body: this.entity.body || '',
            meetingLocation: this.entity.meetingLocation || '',
            meetingIsOnline: this.entity.meetingIsOnline || false,
            meetingOnlineUrl: this.entity.meetingOnlineUrl || ''
          };
          if (this.entity.startAt) {
            const startDate = this.entity.startAt instanceof Date ? this.entity.startAt : new Date(this.entity.startAt);
            request.startAt = startDate.toISOString();
          }
          if (this.entity.endAt) {
            const endDate = this.entity.endAt instanceof Date ? this.entity.endAt : new Date(this.entity.endAt);
            request.endAt = endDate.toISOString();
          }
          await ajax.post('/api/v1/agency/activities/meetings', request);
        }
      } else {
        // Update existing activity using type-specific endpoints
        const activityId = this.activity!.id;
        const baseUrl = `/api/v1/agency/activities/${activityId}`;

        // Note details
        if (this.editIsNote) {
          await ajax.put(`${baseUrl}/note-details`, {
            body: this.entity.body || '',
            categoryId: this.entity.categoryId || null,
            branchId: this.entity.branchId || null,
            deskId: this.entity.deskId || null,
            updatedAt: this.entity.updatedAt
          });
        }

        // Task details
        else if (this.editIsTask) {
          const request: any = {
            subject: this.entity.subject,
            body: this.entity.body || '',
            categoryId: this.entity.categoryId || null,
            branchId: this.entity.branchId || null,
            deskId: this.entity.deskId || null,
            ownerId: this.entity.owner?.id || null,
            taskPriority: this.entity.taskPriority,
            status: this.entity.status,
            updatedAt: this.entity.updatedAt
          };
          if (this.entity.endAt) {
            const endDate = this.entity.endAt instanceof Date ? this.entity.endAt : new Date(this.entity.endAt);
            request.endAt = endDate.toISOString();
          }
          await ajax.put(`${baseUrl}/task-details`, request);
        }

        // Call details
        else if (this.editIsCall) {
          const request: any = {
            subject: this.entity.subject,
            body: this.entity.body || '',
            categoryId: this.entity.categoryId || null,
            branchId: this.entity.branchId || null,
            deskId: this.entity.deskId || null,
            direction: this.entity.direction,
            phoneNumber: this.entity.phoneNumber || '',
            callOutcome: this.entity.callOutcome,
            updatedAt: this.entity.updatedAt
          };
          if (this.entity.startAt) {
            const startDate = this.entity.startAt instanceof Date ? this.entity.startAt : new Date(this.entity.startAt);
            request.startAt = startDate.toISOString();
          }
          if (this.entity.endAt) {
            const endDate = this.entity.endAt instanceof Date ? this.entity.endAt : new Date(this.entity.endAt);
            request.endAt = endDate.toISOString();
          }
          await ajax.put(`${baseUrl}/call-details`, request);
        }

        // Meeting details
        else if (this.editIsMeeting) {
          const request: any = {
            subject: this.entity.subject,
            body: this.entity.body || '',
            categoryId: this.entity.categoryId || null,
            branchId: this.entity.branchId || null,
            deskId: this.entity.deskId || null,
            meetingLocation: this.entity.meetingLocation || '',
            meetingIsOnline: this.entity.meetingIsOnline || false,
            meetingOnlineUrl: this.entity.meetingOnlineUrl || '',
            updatedAt: this.entity.updatedAt
          };
          if (this.entity.startAt) {
            const startDate = this.entity.startAt instanceof Date ? this.entity.startAt : new Date(this.entity.startAt);
            request.startAt = startDate.toISOString();
          }
          if (this.entity.endAt) {
            const endDate = this.entity.endAt instanceof Date ? this.entity.endAt : new Date(this.entity.endAt);
            request.endAt = endDate.toISOString();
          }
          await ajax.put(`${baseUrl}/meeting-details`, request);
        }

        // Email details
        else if (this.editIsEmail) {
          await ajax.put(`${baseUrl}/email-details`, {
            categoryId: this.entity.categoryId || null,
            branchId: this.entity.branchId || null,
            deskId: this.entity.deskId || null,
            updatedAt: this.entity.updatedAt
          });
        }
      }

      this.$emit('saved');
    } catch (error) {
      AppModule.handleApiError(error);
    } finally {
      this.saving = false;
    }
  }

  /**
   * Builds recipient request objects from email address strings.
   */
  buildRecipientRequests(emails: string[]): { email: string; name: string }[] {
    return (emails || []).map((email: string) => {
      const option = this.availableEmailOptions.find(opt => opt.email === email);
      return { email, name: option ? option.name : '' };
    });
  }

  /**
   * Creates an email draft on the backend and stores the draft ID for subsequent operations.
   *
   * Callers can arrive concurrently, so this is idempotent per compose: if a
   * draft already exists it returns, and a second caller awaits the in-flight
   * POST rather than creating another draft.
   */
  async createEmailDraft() {
    if (this.draftActivityId) {
      return;
    }
    if (this.draftCreateRequest) {
      await this.draftCreateRequest;
      return;
    }
    this.draftCreateRequest = this.postEmailDraft();
    try {
      await this.draftCreateRequest;
    } finally {
      this.draftCreateRequest = null;
    }
  }

  private async postEmailDraft(): Promise<void> {
    const draftRequest: any = {
      subject: this.entity.subject || '',
      body: this.entity.body || '',
      to: this.buildRecipientRequests(this.entity.emailToAddresses),
      cc: this.buildRecipientRequests(this.entity.emailCcAddresses),
      bcc: this.buildRecipientRequests(this.entity.emailBccAddresses),
      categoryId: this.entity.categoryId || null,
      branchId: this.entity.branchId || null,
      deskId: this.entity.deskId || null
    };

    // Add entity context if provided
    if (this.entity.primaryEntityType) {
      draftRequest.primaryEntityType = this.entity.primaryEntityType;
      draftRequest.companyId = this.entity.companyId || null;
      draftRequest.locationId = this.entity.locationId || null;
      draftRequest.contactId = this.entity.contactId || null;
      draftRequest.workerId = this.entity.workerId || null;
      draftRequest.jobId = this.entity.jobId || null;
      draftRequest.bookingId = this.entity.bookingId || null;
      draftRequest.opportunityId = this.entity.opportunityId || null;
    }

    // Add replied-to activity ID if this is a reply
    if (this.entity.repliedToActivityId) {
      draftRequest.repliedToActivityId = this.entity.repliedToActivityId;
    }

    const response = await ajax.post('/api/v1/agency/activities/emails/outbound', draftRequest);
    const activity = response.data;
    if (activity && activity.id) {
      this.draftActivityId = activity.id;
      this.draftUpdatedAt = activity.updatedAt ? new Date(activity.updatedAt) : null;
    }
  }

  /**
   * Saves the current email draft (creates one if it doesn't exist yet).
   */
  async saveEmailDraft() {
    this.draftSaving = true;
    try {
      // If no draft exists yet, create one first
      if (!this.draftActivityId) {
        await this.createEmailDraft();
        if (!this.draftActivityId) return; // Creation failed
      }

      // Update the existing draft
      const updateRequest: any = {
        updatedAt: this.draftUpdatedAt,
        subject: this.entity.subject || '',
        body: this.entity.body || '',
        to: this.buildRecipientRequests(this.entity.emailToAddresses),
        cc: this.buildRecipientRequests(this.entity.emailCcAddresses),
        bcc: this.buildRecipientRequests(this.entity.emailBccAddresses),
        categoryId: this.entity.categoryId || null
      };

      const response = await ajax.put(
        `/api/v1/agency/activities/emails/outbound/${this.draftActivityId}`,
        updateRequest
      );
      this.draftUpdatedAt = response.data.updatedAt ? new Date(response.data.updatedAt) : null;
      this.$emit('saved');
    } catch (error) {
      AppModule.handleApiError(error);
    } finally {
      this.draftSaving = false;
    }
  }

  /**
   * Saves the draft then sends the email.
   */
  async sendEmail() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    this.draftSending = true;
    try {
      // Save draft first to persist latest changes
      if (!this.draftActivityId) {
        await this.createEmailDraft();
      }
      if (!this.draftActivityId) return;

      // Update draft with latest content before sending
      const updateRequest: any = {
        updatedAt: this.draftUpdatedAt,
        subject: this.entity.subject || '',
        body: this.entity.body || '',
        to: this.buildRecipientRequests(this.entity.emailToAddresses),
        cc: this.buildRecipientRequests(this.entity.emailCcAddresses),
        bcc: this.buildRecipientRequests(this.entity.emailBccAddresses),
        categoryId: this.entity.categoryId || null
      };

      const updateResponse = await ajax.put(
        `/api/v1/agency/activities/emails/outbound/${this.draftActivityId}`,
        updateRequest
      );
      this.draftUpdatedAt = updateResponse.data.updatedAt ? new Date(updateResponse.data.updatedAt) : null;

      // Send
      await ajax.post(
        `/api/v1/agency/activities/emails/outbound/${this.draftActivityId}/send`
      );
      this.$emit('saved');
    } catch (error) {
      AppModule.handleApiError(error);
    } finally {
      this.draftSending = false;
    }
  }

  /**
   * Gets the primary entity ID based on the primary entity type.
   */
  getPrimaryEntityId(): string | null {
    if (!this.entity.primaryEntityType) return null;

    switch (this.entity.primaryEntityType) {
      case ActivityEntityType.Contact:
        return this.entity.contactId || null;
      case ActivityEntityType.Worker:
        return this.entity.workerId || null;
      case ActivityEntityType.Company:
        return this.entity.companyId || null;
      case ActivityEntityType.Location:
        return this.entity.locationId || null;
      case ActivityEntityType.Job:
        return this.entity.jobId || null;
      case ActivityEntityType.Booking:
        return this.entity.bookingId || null;
      case ActivityEntityType.Opportunity:
        return this.entity.opportunityId || null;
      default:
        return null;
    }
  }

  async completeTask() {
    if (!this.activity) return;
    this.completing = true;
    try {
      await ajax.put(`/api/v1/agency/activities/${this.activity.id}/status`, {
        status: ActivityStatus.Completed,
        updatedAt: this.activity.updatedAt
      });
      this.$emit('updated');
    } catch (error) {
      AppModule.handleApiError(error);
    } finally {
      this.completing = false;
    }
  }

  openFullPage() {
    if (this.activity) {
      this.$router.push({ name: PageNames.AgencyActivityDetails, params: { activityid: this.activity.id } });
    }
  }
}
